<template>
  <div class="d-flex flex-column" style="line-height: 12px;">
    <p class="m-0 font-weight-bold" style="font-size: 11px;">
      {{params.data.CardName}}
      <span class="text-muted font-weight-normal">{{params.data.CardCode}}</span>
    </p>
    <p class="m-0 text-muted" style="font-size: 11px;">
      <span class="font-weight-normal pr-1 text-gray">{{params.data.ShipToCode}}</span>
      <span class="font-weight-light">{{params.data.Address2}}</span>
    </p>
  </div>
</template>

<script>
  export default {
    created() {
    },
  }
</script>

<style lang="scss" scoped>

</style>